<template>
    <div class="user-password">
        <h2>Change Password</h2>
        <el-form :model="form" ref="form" label-width="160px" label-position="right">
            <el-form-item label="New Passowrd" prop="password">
                <el-input
                    v-model="form.password"
                    autocomplete="off"
                    placeholder="Password"
                    show-password
                ></el-input>
            </el-form-item>
            <el-form-item label="Repeat new password" prop="repassword">
                <el-input
                    v-model="form.repassword"
                    autocomplete="off"
                    placeholder="Repeat your password"
                    show-password
                ></el-input>
            </el-form-item>
        </el-form>
        <User2FaInputer v-if="show2Fa" :onInput="on2FaInput" :onComplete="on2FaComplete" :processing="processing" />
        <div>
            <el-button @click="onSubmit" type="primary">Reset password</el-button>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapState } from "vuex";
import User2FaInputer from "./User2FAInputer";

export default {
    name: "UserPassword",
    components: {
        User2FaInputer
    },
    data() {
        return {
            show2Fa: false,
            form: {
                password: "",
                repassword: "",
                auth2fa: "",
            },
            processing: false,
        };
    },
    mounted() {
        if(this.userInfo && this.userInfo.is_2fa_enabled) {
            this.show2Fa = true;
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.userInfo,
            arrayBufferToBase64: state => state.arrayBufferToBase64
        }),
        showDetail() {
            if (this.selectedData) {
                return true;
            }
            return false;
        },
        isMatchPassword() {
            return this.form.password.trim() == this.repassword.trim();
        }
    },
    methods: {
        ...mapActions(["request","setAccessToken", "getError"]),
        validateForm() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        on2FaInput(code) {
            this.form.auth2fa = code;
        },
        on2FaComplete(code) {
            this.form.auth2fa = code;
            if(this.form.repassword.length > 0 && this.form.password.length > 0 && this.form.auth2fa.length == 6) {
                this.onSubmit();
            }
        },
        onSubmit() {
            let ctrl = this;
            ctrl.processing = true;
            ctrl.$confirm("You will be log off once you have successfully changed your password.", "Do you wish to change your password", {
                confirmButtonText: `Confirm`,
                cancelButtonText: "Cancel",
                type: "warning"
            })
                .then(() => {
                    ctrl.request({
                        method: "PATCH",
                        endpoint: `authenticate/changepwd`,
                        data: this.form
                    })
                        .then(() => {
                            this.$message({
                                message: "Your password has been changed",
                                type: "success"
                            });
                            setTimeout(() => {
                                this.setAccessToken();
                                this.$router.push({ path: "/" });
                            }, 1500);
                        })
                        .catch(err => {
                            ctrl.getError({
                                err,
                                title: "AUTHENTICATE_ERROR",
                                message: "Password change failed"
                            }).then(ctrl.$notify);
                            if(err && err.data && err.data.name == "AUTHENTICATE_2FA_REQUIRED"){
                                ctrl.show2Fa = true;
                            }
                        })
                        .finally(() => {
                            setTimeout(() => {
                                ctrl.processing = false;
                            }, 500);
                        });
                })
                .catch(() => {});
        }
    }
};
</script>
<style scoped>
.user-password {
    width: 550px;
    padding: 32px;
    color: #555;
    height: 100%;
    background-color: #eee;
}
.user-password h2 {
    padding: 0px 0px 24px;
}
.user-password button {
    width: 100%;
}

</style>

<style >

.user-password label {
    color: #555;
}
</style>